import React, { useState, useEffect } from "react";
import { Tab, Nav, Container, Form } from "react-bootstrap";
import SaveChanges from "./SaveChanges";
import updateParams from "utils/updateParams.js";
import Users from "./Users"
import Customizations from "./Customizations"
import OrgInfo from "./OrgInfo"

export default function Organizations(props) {
  const [tabLocation, setTabLocation] = useState("orgInfo");
  const [isOwner, setIsOwner] =  useState((props.current_user.id === props.owner.id) || props.current_user_is_god)

  const servicePicker = (searchParams) => {
    if (searchParams.toString().includes("customizations")) {
      return "customizations"
    }
    if (searchParams.toString().includes("users")) {
      return "users"
    }
  }

  const handleOwnershipTransfer = (user_id) => {
    $.ajax({
			type: "POST",
			url: "/datapulse/organization/transfer-ownership/",
			data: {
				org_id: props.org.id,
        user_id: user_id
			},
		});
  }

  const handleOrgDelete = () => {
    // Nothing on this url yet, just psuedocode
    $.ajax({
			type: "POST",
			url: "/datapulse/organization/delete/",
			data: {
				org_id: props.org.id
			},
		});
  }
  
  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "orgInfo";
    }
    if (page === "customizations") {
      setTabLocation(page);
      updateParams("page", page);
      updateParams("sub_page", servicePicker(searchParams));
    }
    else {
    setTabLocation(page);
    updateParams("page", page);
    }
  }, []);

  const selectTab = (key) => {
    if (key === "services") {
      setTabLocation(key);
      updateParams("page", key);
      updateParams("sub_page", servicePicker(searchParams));
    }
    else {

      setTabLocation(key);
      updateParams("page", key);
    }
  };

  return (
    <div className="organizations">
            <input hidden name="selected_page" value={tabLocation} readOnly />
            <Tab.Container id="organization-tabs" defaultActiveKey="orgInfo" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
              {/* <Nav variant="pills" className="nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                <Nav.Item className="col">
                  <Nav.Link eventKey="orgInfo" className="tab-titles sub-nav-item" data-link-type="page">
                    <p className="">Organization Info</p>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link eventKey="customizations" className="tab-titles sub-nav-item" data-link-type="page">
                    Customizations/Departments
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link eventKey="users" data-link-type="page" className="tab-titles sub-nav-item">
                    Users
                  </Nav.Link>
                </Nav.Item>
              </Nav> */}
              <Tab.Content>
                <Tab.Pane eventKey="orgInfo">
                  <OrgInfo {...props} isOwner={isOwner} isPrimaryOrg={props.is_primary_org} handleOwnershipTransfer={handleOwnershipTransfer} handleOrgDelete={handleOrgDelete} />
                </Tab.Pane>
                <Tab.Pane eventKey="customizations">
                  <SaveChanges page={tabLocation}/>
                  <Customizations {...props} isOwner={isOwner} />
                </Tab.Pane>
                <Tab.Pane eventKey="users">
                  {/* <SaveChanges page={tabLocation}/> */}
                  <Users {...props} isOwner={isOwner} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
        {/* </Form> */}
    </div>
  );
}
